<template>
    <b-modal
      id="manufacturer-modal"
      hide-header
      hide-footer
      no-stacking
      centered
      size="lg"
      @show="onShow"
    >
      <div class="header">
        <div class="header-content">
          <p>Adicionar fabricante</p>  
          <Close @click="closeModal" />
        </div>
      </div>
  
      <hr>
  
      <div class="bottom">
        <div class="body">
          <div class="row">
            <div class="col-12 mb-3">
              <b-form-group>
                <label for="name" class="title">Fabricante</label>
                <b-form-input
                  trim
                  id="name"
                  autocomplete="off"
                  placeholder="Descrever"
                  v-model="form.name"
                  ref="name"  
                />
              </b-form-group>
            </div>
          </div>          
        </div>
  
        <div class="footer">
          <button class="confirm-button p-2" @click="createOrUpdate">
            Salvar
          </button>
        </div>
      </div>
  
    </b-modal>
  </template>
  
  <script>  
  export default {
    components: {
        Close: () => import('@/assets/icons/close.svg'),
    },
    data() {
      return {
        clinic: JSON.parse(localStorage.getItem('clinic')),
        form: {}
      }
    },
    props: {
      manufacturer: {
        type: Object,
        default: () => ({})
      },
    },
    methods: {
      onShow() {
      },
      closeModal() {
        this.$bvModal.hide('manufacturer-modal')
      },
      async createOrUpdate() {
        if(this.form.id){
          this.api.updateWarehouseManufacturer(this.form.id, {
            name: this.form.name,
            clinic_id: this.clinic.id
          }).then(res => {
            this.$emit('reload');
            this.$bvModal.hide('manufacturer-modal');
          });
        } else {
          this.api.addWarehouseManufacturer({
            name: this.form.name,
            clinic_id: this.clinic.id
          }).then(res => {
            this.$emit('reload');
            this.$bvModal.hide('manufacturer-modal');
          });
        }
      },
    },
    watch: {
      manufacturer: {
        handler(manufacturer) {
            this.form = { ... manufacturer }
          },
          immediate: true,
      },
    }
  }
  </script>
  
  <style lang="scss">
  #manufacturer-modal {
    font-family: 'Nunito Sans';
    font-style: normal;
  
    .modal-content {
      top: 50%;
      left: 50%;
      transform: translate(-50%, 0);
      max-width: 800px;
  
      .modal-body {
        padding: 0;
  
        .header {
          .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px;
  
            p {
              font-weight: 600;
              font-size: 18px;
              line-height: 28px;
              color: #525C7A;
            }
  
            svg {
              height: 24px;
              width: 24px;
              fill: #7F91D2;
              cursor: pointer;
            }
          }
        }
  
        hr {
          margin: 0;
        }
  
        .bottom {
          display: flex;
          flex-direction: column;
          gap: 40px;
          padding: 24px;
  
          .body {
            .radio-container {
              display: flex;
              flex-direction: column;
              gap: 24px;
  
              p {
                font-family: 'Red Hat Display';
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 134%;
                letter-spacing: -0.01em;
                color: #0C1D59;
              }
  
              .radio-section {
                display: flex;
                flex-direction: column;
                gap: 16px;
  
                .radio {
                  display: flex;
                  align-items: center;
                  gap: 12px;
  
                  label {
                    margin: 0;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 150%;
                    color: #525C7A;
                    cursor: pointer;
                  }
  
                  input {
                    height: 24px;
                    width: 24px;
                    cursor: pointer;
                  }
                }
              }
            }
  
            hr {
              margin: 24px 0;
            }
          }
  
          .footer {
            display: flex;
            justify-content: end;
  
            .confirm-button {
              border: none;
              padding: 14px 16px;
              background: #305BF2;
              border-radius: 8px;
              color: #FFFFFF;
              font-size: 14px;
              font-weight: 600;
              line-height: 24px;
              width: 100px;
            }
          }
        }
      }
    }
  }
  </style>
  